import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from '../res/axios';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../res/actions';
import { connect } from 'react-redux';
import { Cards, Table, Popover, ColumnLayout } from '@amzn/awsui-components-react/polaris';
import {Button} from "@amzn/awsui-components-react";


const mapStateToProps = (state) => {
    return {
      user: state.appState.user,
      leaderboards: state.leaderboards,
      loading: state.appState.isLoading,
      serverClientTimeOffset: state.appState.serverClientTimeOffset
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
      addNotification: actionCreators.addNotification,
      setLeaderboardsList: actionCreators.setLeaderboardsList,
      clearLeaderboardsList: actionCreators.clearLeaderboardsList,
      setLoggedInUser: actionCreators.setLoggedInUser,
      setServerClientTimeOffset: actionCreators.setServerClientTimeOffset,
    }, dispatch);
  }
  
  let data = ''
  
class Leaderboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    if (this.props.leaderboardsStatus !== true){
      this.setState({
        loading: true
      });
      let headers = {
        'x-csrf-token': localStorage.getItem('BOTSE_SESSION_TOKEN'),
        'Action': 'Leaderboard:ListLeaderboards'
      };
      
      axios.get("action", { headers: headers })
        .then(res => {
          res.data = JSON.parse(res.data);
          data = res.data.data.leaderboards
          this.props.setLeaderboardsList(data);
          this.props.leaderboardsStatus = true
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          this.props.clearLeaderboardsList();
          this.props.leaderboardsStatus = false
          this.setState({
            loading: false,
          });
          console.log(error);
          var notification = {
            id: 1,
            type: "error",
            dismissible: true,
            header: "Failed to fetch the leaderboard list!",
            content: "Please try reloading the page, or submit a ticket if this issue persists.",
          };
          this.props.addNotification(notification);
        });
    }
  }

  render() {
    let itemArray = this.props.leaderboards.map(item => {
      return {
        "userAlias": item.userAlias,
        "totalPoints": item.totalPoints
      };
    })
      let itemArrayTotalPoints = itemArray.sort(
        function(a, b) {          
           if (a.totalPoints === b.totalPoints) {
              return b.totalLabsPassed - a.totalLabsPassed;
           }
           return b.totalPoints - a.totalPoints;
        });
      itemArrayTotalPoints = itemArrayTotalPoints.splice(0, 10)

      return(
        <div style={{ display: "flex" }} id="leaderboard_table_container"> 
        
          <Cards header={<h2>Leaderboard</h2>} cardsPerRow={[{ cards: 1 },{ cards: 1 }]}>
            <ColumnLayout>
              <div data-awsui-column-layout-root="true">
                <div>
                  <Popover
                    style={{ marginLeft: "auto "}}
                    dismissButton={false}
                    position="left"
                    header={<h1>Points</h1>}
                    content={<ColumnLayout>
                    <div>
                      <p>
                        Points are earned on the first pass of a challenge. Passing on the first attempt earns 6 points, 4 points for the second attempt, 2 points for the third attempt, and 1 point for successive attempts.
                      </p>
                    </div>
                    </ColumnLayout>}
                  >
                    Scoring Info
                  </Popover>
                </div>
                <div>
                  <Table
                    id = "FirstLeaderboardTable"
                    style={{ marginRight: "auto "}}
                    columnDefinitions={[
                      {
                        id: "userAlias-FirstLeaderboardTable",
                        header: "User Alias",
                        cell: e => e.userAlias, 
                        sortingField: "userAlias"
                      },
                      {
                        id: "totalPoints-FirstLeaderboardTable",
                        header: "Total Points Scored",
                        cell: e => e.totalPoints
                      },
                    ]}
                    trackBy="name"
                    items = {itemArrayTotalPoints}
                    loading={this.state.loading}
                    loadingText="Loading leaderboard"
                    empty={
                    <div className="awsui-util-t-c">
                      <div className="awsui-util-pt-xs awsui-util-mb-xs">
                        <b>No leaderboard</b>
                      </div>
                      <p className="awsui-util-mb-s">No leaderboard found</p>
                    </div>
                    }/>
                  </div>
                </div>
              </ColumnLayout>
          </Cards>
        </div>
      )
  }
}

const LeaderboardWithRouter = withRouter(Leaderboard);
export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardWithRouter);



// WEBPACK FOOTER //
// ./src/app/components/Leaderboard.jsx